import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

class SharedErrorHandler {
    handleError(error) {
        const chunkFailedMessage = /Loading chunk [\d]+ failed/;
        if (chunkFailedMessage.test(error.message)) {
            console.error(`Chunk error. Reloading...`);
            location.reload();
        }
    }
}
SharedErrorHandler.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SharedErrorHandler, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
SharedErrorHandler.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SharedErrorHandler, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: SharedErrorHandler, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/*
 * Public API Surface of ng-components,
 * Only those should be placed here that are supposed to be used in EVERY angular project
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SharedErrorHandler };
